import { HeaderTopBarComponent } from "./../../../congress/shared/layout/header-top-bar/header-top-bar.component";
import {
    Component,
    OnInit,
    Injector,
    ViewChild,
    ViewEncapsulation,
    Injectable,
    Input,
} from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";
import { CartHelperService, ICart } from "../cart/cart-helper-service";
import { HeaderComponent } from "@app/shared/layout/header.component";
import { CheckoutModalComponent } from "congress/shared/layout/checkout/checkout-modal/checkout-modal.component";

export interface IFormattedItemCart {
    text: string;
    value: number;
    memberAnnuity: any;
    registratuion: any;
}

@Component({
    templateUrl: "./cart-header.component.html",
    selector: "[cartHeader]",
    encapsulation: ViewEncapsulation.None,
})
@Injectable()
export class CartHeaderComponent extends AppComponentBase implements OnInit {
    @Input() icon: string = "fa fa-shopping-cart";
    @Input() color: string = undefined;
    @Input() showCartLink: boolean = true;
    @Input() headerImage: string =
        "assets/metronic/dist/html/default/assets/demo/default/media/img/misc/notification_bg.jpg";
    @Input() showItemsNumber: boolean;
    @Input() showCheckoutModal: boolean = false;
    @Input() showRemoveItens: boolean = false;
    @Input() showCheckoutButton: boolean = false;

    cart: ICart = undefined;

    items: IFormattedItemCart[] = [];
    countItens = 0;

    constructor(
        injector: Injector,
        private _cartHelperService: CartHelperService,
        private _headerComponent: HeaderTopBarComponent
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.loadCart();
        this.registerToEvents();
    }

    registerToEvents() {
        abp.event.on("app.cart.refresh", () => {
            this.loadCart();
        });
    }

    loadCart(): void {
        this.cart = this._cartHelperService.loadCart();
        this.countItens =
            this.cart.memberAnnuities.length + this.cart.registrations.length;

        let cartItems = [];

        this.cart.memberAnnuities.forEach((x) => {
            cartItems.push({
                text: x.annuity.year,
                value: x.memberAnnuity.payments ? x.memberAnnuity.payments[0].totalPaid : 0,
                memberAnnuity: x.memberAnnuity
            });
        });
        this.cart.registrations.forEach((x) => {

            cartItems.push({
                text: x.event.name,
                value: x.registration.payments ? x.registration.payments[0].totalPaid : 0,
                registration: x.registration
            });
        });

        this.items = [];
        for (let i = 0; i < cartItems.length && i < 3; i++) {
            this.items.push(cartItems[i]);
        }
    }

    showCheckout() {
        this._headerComponent.showCheckout();
    }

    getCart() {
        this.cart = this._cartHelperService.getCart();
        abp.event.trigger("app.cart.refresh");
    }


    removeMemberAnnuityFromCart(annuityId: number) {
        this._cartHelperService.removeMemberAnnuityById(annuityId);

        this.getCart();
    }


    removeRegistrationFromCart(item: number) {
        this._cartHelperService.removeRegistrationByEventId(item);

        this.getCart();
    }
}



// WEBPACK FOOTER //
// ./src/app/store/cart-header/cart-header.component.ts